const calculateTradeMetrics = ({
    price,
    size,
    leverage,
    balance,
    side = "BUY" // or "SELL"
}) => {
    const parsedPrice = parseFloat(price) || 0;
    const parsedSize = parseFloat(size) || 0;
    const parsedLeverage = parseFloat(leverage) || 1;
    const parsedBalance = parseFloat(balance) || 0;

    // Notional Cost (Price × Size)
    const cost = (parsedPrice * parsedSize).toFixed(2);

    // Max Size (Balance × Leverage) / Price
    const max = ((parsedBalance * parsedLeverage) / parsedPrice).toFixed(3);

    // Liq Price estimate (simplified logic, not exact Binance formula)
    let liqPrice = 0;
    let sellliqPrice = 0;

    liqPrice = (parsedPrice * (1 - 1 / parsedLeverage)).toFixed(2);
    sellliqPrice = (parsedPrice * (1 + 1 / parsedLeverage)).toFixed(2);

    return {
        cost,
        max,
        liqPrice,
        sellliqPrice,
    };
};


export default calculateTradeMetrics;